module.exports = __webpack_public_path__ + "static/media/maps-marker-green.a93566e0.svg";